import React, { Suspense } from 'react';
import { Box, Grid, Container, Stack } from '@mui/material';

import i18n from 'i18n-js';
import Can from 'components/Can';
import Title from 'components/Title';
import Layout from 'components/Layout';
import { useSelector } from 'react-redux';
import Comments from 'components/Comments';
import * as Components from './RelatedComponent';
import { Details, AlarmLogs } from 'components/Alarms';
import { FormsWidget } from 'components/Forms';
import { withRouter, useParams } from 'react-router-dom';

const AlarmsDetails = () => {
  const { id } = useParams();

  const { current } = useSelector((state) => state.alarms || {});

  const instance = () => {
    const { primary_object_type, primary_object_id } = current;
    const Component = Components[primary_object_type] ?? null;
    if (!Component) return;
    return <Component key={1} id={primary_object_id} />;
  };

  return (
    <Layout title={i18n.t('alarm.details')}>
      <Container maxWidth={false} disableGutters>
        <Box>
          <Box sx={{ mb: 4.5 }}>
            <Title title={`${i18n.t('alarm.details')} ID #${id}`} />
          </Box>
          <Grid container spacing={2} sx={{ m: 0, width: '100%' }}>
            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
              <Stack spacing={2}>
                <Details id={id} />
                <Can I="read" on="event_log">
                  <AlarmLogs id={id} />
                </Can>
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
              <Stack spacing={2}>
                {current?.primary_object_type && (
                  <Suspense fallback={<div>Loading...</div>}>{instance()}</Suspense>
                )}
                <Can I="read" a="comment">
                  <Comments type="alarm" id={parseInt(id)} />
                </Can>
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
              <Stack spacing={2}>
                {current?.primary_object_type === i18n.t('forms.reservation_driver') && (
                  <FormsWidget type="reservation" id={parseInt(current?.primary_object_id)} />
                )}
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Layout>
  );
};

export default withRouter(AlarmsDetails);
